import { useTranslation } from "react-i18next";
import { Modal } from 'antd';
import { Form } from "antd";
import InputCustom from "../components/InputCustom/InputCustom";
import { prefixSelector, RandomStringID } from "../util";
import { Button } from "mobily-ui-library/lib";
import { useState } from "react";
import CloseIcon from '../assets/Close.svg';
import { createLead } from "../api/apigeeApi";
import SuccessModal from "../components/SuccessModal/SuccessModal";
import { v4 as uuid } from "uuid";

interface Props {
    rtl: boolean;
}
const alphaNumeric = /^[0-9]{10}$/;
const mobilePattern = /^((2|5|0|3|6|4|9|1|8|7)([0-9]{8})){0,9}$/;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function Page({ rtl }: Props) {
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false)
    const { t } = useTranslation();
    const initialValues = {
        firstname: '',
        lastname: '',
        mobileNumber: '',
        prefix: '966',
        crNumber: '',
        companyName: '',
        email:''
    }
    const onValuesChange = () => {
        setTimeout(()=>{
            setIsFormValid(form.isFieldsTouched(['firstname', 'lastname', 'mobileNumber', 'crNumber', 'companyName', 'email'], true) && form.getFieldsError().every(({ errors }) => errors.length === 0))
        }, 0);
      };
    const handleNext = async (values: any) => {
        const createId = uuid()
        const ID = createId.replaceAll(/-/g, "").toUpperCase();
        const UUID = createId;
        const data = {
            messageBasicInfo: {
                id: ID,
                uuid: UUID,
                creationDateTime: new Date().toISOString(),
                operationId: "B2B-004"
            },
            basicLeadInfo: {
                leanLeadInfo: {
                    id: RandomStringID(10, 'aA'),
                    name: `Request a call lead for ${values.companyName}`,
                    prospectParty: {
                        prospectPartyId: RandomStringID(8, '#'),
                        prospectDetails: {
                            companyName: values.companyName
                        },
                        address: {
                            MobileFormattedNumberDescription: `+${values.prefix}${values.mobileNumber}`,
                            emailURI: values.email,
                            telephoneFormattedNumberDescription: ""
                        },
                        contactParty: {
                            partyId: RandomStringID(8, '#'),
                            contactDetails: {
                                personFirstName: values.firstname,
                                personLastName: values.lastname
                            }
                        }
                    }
                }
            },
            leadDetails: {
                zAccountIdNumber: values.crNumber,
                zKUTComments: "",
                zKUTServiceName: localStorage.getItem('productType'),
                zKUTProduct: "Request A Call"
            }
        }
        try {
            const res = await createLead(data);
            if (res.status === 202) {
                setIsSuccess(true)
            }
        } catch (err) {
            console.log(err);
            const win: any = window;
            if (win["errorPageURL"]) {
                document.location.href = win["errorPageURL"];
            }
        }
        
    }
    const validateCRNumber = (_: any, value: string) => {
        if (value && !alphaNumeric.test(value)) {
            return Promise.reject(t("Verify_entered_data"));
        }
        return Promise.resolve();
    }
    const validateMobileNumber = (_: any, value: string) => {
        if (value && !mobilePattern.test(value)) {
            return Promise.reject(t("Verify_entered_data"));
        }
        return Promise.resolve();
    }
    const validateEmail = (_: any, value: string) => {
        if (value && !emailPattern.test(value)) {
            return Promise.reject(t("enter_valid_email"));
        }
        return Promise.resolve();
    }
    return (
        <div className="ds-contact-form">
            <Modal 
                open={true}
                footer={null}
                className="modal-container-cc"
                // centered
                closeIcon={<img src={CloseIcon} alt='icon' />}
                onCancel={()=>window.history.back()}
            >
                {!isSuccess && <div className={`contact-form ${rtl ? 'ar' : ''}`}>
                    <div className="title">
                        {t('Contact_info')}
                    </div>
                    <div className="sub-title">
                        {t('Contact_Form_subTitle')}
                    </div>
                    <Form form={form} name="contactForm" initialValues={initialValues} onFinish={handleNext} onValuesChange={onValuesChange}>
                        <InputCustom
                            rtl={rtl}
                            headingleft={t("First_name")}
                            name="firstname"
                            maxLength={40}
                            placeholder={t("First_name_placeholder")}
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("First_name")}` },
                                { pattern: /^[a-zA-Z ]*$/, message: t("Verify_entered_data")}
                            ]}
                        />
                        <InputCustom
                            rtl={rtl}
                            headingleft={t("Last_name")}
                            name="lastname"
                            maxLength={40}
                            placeholder={t("Last_name_placeholder")}
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("Last_name")}` },
                                { pattern: /^[a-zA-Z ]*$/, message: t("Verify_entered_data")}
                            ]}
                        />
                        <InputCustom
                            rtl={rtl}
                            maxLength={9}
                            headingleft={t("Phone_number")}
                            prefixSelector={prefixSelector}
                            placeholder={t("Phone_number_placeholder")}
                            name="mobileNumber"
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("Phone_number")}` },
                                { validator: validateMobileNumber }
                            ]}
                        />
                          <InputCustom
                            rtl={rtl}
                            maxLength={50}
                            headingleft={t("email")}
                            placeholder={t("email_placeholder")}
                            name="email"
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("email")}` },
                                { validator: validateEmail }
                            ]}
                        
                            
                        />
                        <InputCustom
                            rtl={rtl}
                            headingleft={t("Company_Name")}
                            placeholder={t("Company_Name_placeholder")}
                            name="companyName"
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("Company_Name")}` },
                                { pattern: /^[0-9a-zA-Z]*$/, message: t("Verify_entered_data")}
                            ]}
                        />
                        <InputCustom
                            rtl={rtl}
                            maxLength={10}
                            headingleft={t("Company_CR_No")}
                            placeholder={t("Company_CR_No_placeholder")}
                            name="crNumber"
                            rules={[
                                { required: true, message: `${t("Please_Enter")} ${t("Company_CR_No")}` },
                                { validator: validateCRNumber }
                            ]}
                        />
                        <Button width={"155px"} htmlType='submit' rtl={rtl} className={`submit-button ${isFormValid ? '' : 'disabled'}`}>
                            {t("Submit")}
                        </Button>
                    </Form>
                </div>}
                {isSuccess && <SuccessModal rtl={rtl} />}
            </Modal>
        </div>
    )
}

export default Page